// firebase-config.js

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { getFirestore } from "firebase/firestore";


const app = firebase.initializeApp({
  apiKey: 'AIzaSyAbXC6DmZwW1R2xDv28_pNViToMrPtBoHI',
  authDomain: 'inventorymanagementsyste-e2b98.firebaseapp.com',
  projectId: 'inventorymanagementsyste-e2b98',
  storageBucket: 'inventorymanagementsyste-e2b98.appspot.com',
  messagingSenderId: '122713339948',
  appId: '1:122713339948:web:f1e4507ca70a1dbe0a3989'
});

export const auth = app.auth();
export const db = getFirestore(app); // Initialize Firestore using the app instance
export default app;
